import React from 'react';
import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import { ChangeSubscriptionButton } from './change-subscription-button';
import { ChildrenPropType } from '../../../../prop-types/children';

import commonStyles from '../style.module.less';

export const ChangeSubscriptionButtonWrapper = ({
  children,
  className = commonStyles['subscription-button'],
  isDisabled = false,
  theme = '',
  onClickTrack = noop,
  linkContainerClassName,
}) => {
  return (
    <>
      {theme === 'link' ? (
        <div className={linkContainerClassName}>
          <ChangeSubscriptionButton className={className} isDisabled={isDisabled} onClickTrack={onClickTrack} theme={theme}>
            {children}
          </ChangeSubscriptionButton>
        </div>
      ) : (
        <ChangeSubscriptionButton className={className} isDisabled={isDisabled} onClickTrack={onClickTrack} theme={theme}>
          {children}
        </ChangeSubscriptionButton>
      )}
    </>
  );
};

ChangeSubscriptionButtonWrapper.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClickTrack: PropTypes.func,
  theme: PropTypes.string,
  linkContainerClassName: PropTypes.string,
};
